module.exports = __webpack_public_path__ + "static/media/TMT-CORT010-120-desktop.fe17a515.jpg";